module.exports = __webpack_public_path__ + "static/img/facebook.6a2b1836.png";